
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResizeVerticalCenter as ObiResizeVerticalCenterElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-resize-vertical-center.js';
 
 
 

 
 export const ObiResizeVerticalCenter = createComponent({
   react: React,
   tagName: 'obi-resize-vertical-center',
   elementClass: ObiResizeVerticalCenterElement,
   events: {
     
   }
  });
 
 